/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
import React from 'react';
import { twMerge } from 'utilities/src/twMerge';

import { ThemeEnum } from '../../Theme';

import IconComponent from '../../Icon';
import useButtonTheme from '../shared/themes';
import { IButtonLinkProps } from './_props';
import LinkWrapper from './_LinkWrapper';

function ButtonLink<Theme extends ThemeEnum = ThemeEnum.Blog>({
  children,
  href,
  size = 'Large',
  icon,
  iconName,
  iconSize,
  iconPosition = 'right',
  variant = 'Primary',
  classes = '',
  ariaLabel,
  tabIndex,
  bg,
  variantColor,
  rel,
  target,
  prefetch,
  useNextLink = true,
  download = false,
  onClick = () => {},
  id,
}: IButtonLinkProps<Theme>) {
  const {
    buttonCommonClasses,
    buttonThemeClasses,
    buttonThemeVariantClasses,
    buttonThemeSizeClasses,
    buttonThemeTextClasses,
    buttonThemeIconClasses,
    buttonThemeOnlyIconSizeClasses,
  } = useButtonTheme({ bg, size, variant, variantColor });

  return (
    <LinkWrapper useNextLink={useNextLink} href={href} prefetch={prefetch}>
      <a
        id={id}
        onClick={onClick}
        rel={rel}
        target={target}
        tabIndex={tabIndex}
        aria-label={ariaLabel}
        download={download}
        className={twMerge(
          'w-fit',
          buttonCommonClasses,
          buttonThemeClasses,
          buttonThemeVariantClasses,
          !children && !!icon ? buttonThemeOnlyIconSizeClasses : buttonThemeSizeClasses,
          {
            'flex-row-reverse': iconPosition === 'left',
            [classes]: !!classes,
          },
        )}
      >
        {children && <span className={buttonThemeTextClasses}>{children}</span>}

        <IconComponent
          Icon={icon}
          iconName={iconName}
          size={iconSize}
          options={{
            className: twMerge('transition-colors duration-300', buttonThemeIconClasses),
          }}
          className={twMerge('transition-colors duration-300', buttonThemeIconClasses)}
        />
      </a>
    </LinkWrapper>
  );
}

export default ButtonLink;
